import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Loading03Icon } from '@hugeicons/core-free-icons';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';
import { FadeLoader } from 'react-spinners';

const RoleLoader = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Detecting User Role...');

  useEffect(() => {
    const detectAndRedirect = async () => {
      try {
        console.log('[RoleLoader] Starting detection...');
        const currentToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
        console.log('[RoleLoader] Token found:', !!currentToken);
        
        if (!currentToken) {
          throw new Error("No access token found in storage");
        }

        // 1. Force fetch fresh profile from API
        console.log('[RoleLoader] Fetching profile...');
        const response = await api.get('/deriv/my-accounts');
        console.log('[RoleLoader] API Response:', response);
        
        const { user: apiUser, has_deriv_account, deriv_account } = response.data?.data || response.data;

        // 2. Flatten role object if necessary
        let roleValue = apiUser.role;
        if (typeof roleValue === 'object' && roleValue !== null) {
          roleValue = roleValue.name || roleValue.slug || roleValue.title || 'Unknown';
        }
        console.log('[RoleLoader] Detected Role:', roleValue);

        // 3. Update Global Auth State
        // Failsafe: If has_deriv_account is false/missing but deriv_account object exists, assume linked
        const isDerivLinked = !!has_deriv_account || (deriv_account && Object.keys(deriv_account).length > 0);

        const userData = {
          ...apiUser,
          role: roleValue,
          deriv_linked: isDerivLinked
        };
        
        // Update context with verified data
        login(userData, currentToken, !!localStorage.getItem('access_token'));

        // 4. Decide Redirect based on FRESH data
        setStatus(`Redirecting...`);
        
        setTimeout(() => {
          if (!isDerivLinked) {
            navigate('/link-deriv');
          } else if (!userData.is_onboarded) {
            navigate('/onboarding');
          } else if (roleValue === 'agent') {
            window.location.href = '/dashboard'; 
          } else {
            window.location.href = '/';
          }
        }, 800);

      } catch (err) {
        console.error('[RoleLoader] CRITICAL FAILURE:', err);
        setStatus(`Error: ${err.message || 'Unknown error'}`);
        // Stop auto-redirect to prevent loops. Let user see the error.
      }
    };

    detectAndRedirect();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-off-white dark:bg-dark-bg transition-colors">
      <div className="bg-white/80 dark:bg-dark-surface/80 backdrop-blur-md p-8 rounded-[2.5rem] shadow-float-lg text-center border border-light-gray/20 dark:border-dark-border/20">
        <div className="bg-soft-green/10 p-6 rounded-full inline-block mb-6">
          {status.startsWith('Error') ? (
            <HugeiconsIcon icon={Loading03Icon} size={48} className="text-red-500" />
          ) : (
            <FadeLoader color="#4ade80" />
          )}
        </div>
        <h2 className="text-2xl font-black text-charcoal dark:text-white mb-2">
          {status.startsWith('Error') ? 'Sync Failed' : 'Syncing Profile'}
        </h2>
        <p className="text-muted-gray font-medium mb-6">{status}</p>
        
        {status.startsWith('Error') && (
          <div className="flex gap-4 justify-center">
            <button 
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-soft-green text-white rounded-xl font-bold hover:bg-green-600 transition-colors"
            >
              Retry
            </button>
            <button 
              onClick={() => navigate('/login')}
              className="px-6 py-2 bg-gray-200 dark:bg-gray-700 text-charcoal dark:text-white rounded-xl font-bold hover:bg-gray-300 transition-colors"
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleLoader;